'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _class2, _temp2; // or any other pipeline


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDndMultiBackend = require('react-dnd-multi-backend');

var _reactDndMultiBackend2 = _interopRequireDefault(_reactDndMultiBackend);

var _HTML5toTouch = require('react-dnd-multi-backend/lib/HTML5toTouch');

var _HTML5toTouch2 = _interopRequireDefault(_HTML5toTouch);

var _reactDnd = require('react-dnd');

var _AddLinkButton = require('../containers/AddLinkButton');

var _AddLinkButton2 = _interopRequireDefault(_AddLinkButton);

var _AddSectionButton = require('../containers/AddSectionButton');

var _AddSectionButton2 = _interopRequireDefault(_AddSectionButton);

var _EditableNavigationItem = require('../containers/EditableNavigationItem');

var _EditableNavigationItem2 = _interopRequireDefault(_EditableNavigationItem);

var _NavigationItemList = require('./NavigationItemList');

var _NavigationItemList2 = _interopRequireDefault(_NavigationItemList);

var _NavigationItemEditor = require('../containers/NavigationItemEditor');

var _NavigationItemEditor2 = _interopRequireDefault(_NavigationItemEditor);

var _propTypes3 = require('../propTypes');

var _PreviewNavigationBar = require('./PreviewNavigationBar');

var _PreviewNavigationBar2 = _interopRequireDefault(_PreviewNavigationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavbarAdminForm = (_dec = (0, _reactDnd.DragDropContext)((0, _reactDndMultiBackend2.default)(_HTML5toTouch2.default)), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(NavbarAdminForm, _React$Component);

  function NavbarAdminForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavbarAdminForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarAdminForm.__proto__ || Object.getPrototypeOf(NavbarAdminForm)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      _this.props.fetchNavigationItems();
      _this.props.fetchPages();
    }, _this.generatePreview = function (type, item, style) {
      if (type === 'NAVIGATION_ITEM') {
        return _react2.default.createElement(
          'div',
          { style: _extends({}, style, { width: _this.wrapperDiv.offsetWidth + 'px' }) },
          _react2.default.createElement(_EditableNavigationItem2.default, {
            baseUrl: _this.props.baseUrl,
            navigationItem: item
          })
        );
      }

      return null;
    }, _this.renderError = function () {
      if (_this.props.error) {
        return _react2.default.createElement(
          'div',
          { className: 'alert alert-danger' },
          _this.props.error
        );
      }

      return null;
    }, _this.render = function () {
      if (_this.props.isLoadingNavigationItems || _this.props.isLoadingPages) {
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }

      return _react2.default.createElement(
        'div',
        { ref: function ref(div) {
            _this.wrapperDiv = div;
          } },
        _this.renderError(),
        _react2.default.createElement(_PreviewNavigationBar2.default, { navigationItems: _this.props.navigationItems }),
        _react2.default.createElement(_NavigationItemList2.default, {
          baseUrl: _this.props.baseUrl,
          navigationItems: _this.props.navigationItems
        }),
        _react2.default.createElement(
          'ul',
          { className: 'list-inline mt-2' },
          _react2.default.createElement(
            'li',
            { className: 'list-inline-item' },
            _react2.default.createElement(_AddSectionButton2.default, null)
          ),
          _react2.default.createElement(
            'li',
            { className: 'list-inline-item' },
            _react2.default.createElement(_AddLinkButton2.default, null)
          )
        ),
        _react2.default.createElement(_NavigationItemEditor2.default, { baseUrl: _this.props.baseUrl }),
        _react2.default.createElement(_reactDndMultiBackend.Preview, { generator: _this.generatePreview })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return NavbarAdminForm;
}(_react2.default.Component), _class2.propTypes = {
  fetchNavigationItems: _propTypes2.default.func.isRequired,
  fetchPages: _propTypes2.default.func.isRequired,
  navigationItems: _propTypes3.NavigationItemStorePropType.isRequired,
  isLoadingNavigationItems: _propTypes2.default.bool,
  isLoadingPages: _propTypes2.default.bool,
  baseUrl: _propTypes2.default.string.isRequired,
  error: _propTypes2.default.string
}, _class2.defaultProps = {
  isLoadingNavigationItems: false,
  isLoadingPages: false,
  error: null
}, _temp2)) || _class);
exports.default = NavbarAdminForm;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/NavbarAdminForm.js
// module id = 409
// module chunks = 0